$(document).ready(function() {
  
  // subpages
  if ($('#subpages .subpage').length>0) {
    subpages();
  }
  
  
});

$(window).load(function() {
  background();
});


function subpages() {
  // add arrows
  var subs=$('#content .subpage');
  var nr=0;
  $.each(subs, function(){
    $('h1',this).append('<span class="arrow arrow-up"></span><span class="arrow arrow-down"></span>');
    $(this).addClass('subpage_'+nr+' folded');
    $('.text',this).hide();
    nr++;
  });
  // jump to hash
  var hash=window.location.hash;
  if (hash!=='') {
    $('#content .subpage'+hash).removeClass('folded');
    $('#content .subpage'+hash+' .text').show();
  }
  else {
    // just the first
    $('#content .subpage:first').removeClass('folded');
    $('#content .subpage:first .text').show();
  }
  
  // click
  $(subs).click(function(){
    if ($(this).hasClass('folded')) {
      var self=this;
      // fold all
      $(subs).not(this).each(function(){
        $(this).addClass('folded');
        $('.text',this).hide();
      });
      // unfold choosen
      $.when('.text').done(function(){
        // jump to it
        var id=$(self).attr('id');
        if (id==='')
          window.location.hash = '';
        else
          window.location.hash = '#'+id;
        // Slide open
        $(this).removeClass('folded');
        $('.text',self).slideDown();
      });
    }
    else {
      // Just fold this
      $(this).addClass('folded');
      $('.text',this).slideUp();
    }
  });
}


function background() {
  var tile_size = 188;
  var nr_tiles  = 28;
  var chance    = 0.3;
  var timer     = 2500;
  var fade      = 500;
  
  function random_tile_url(src) {
    var this_chance=chance;
    if (src!==undefined) {
      if (src.indexOf('punt.png')>0) {
        this_chance=1;
      }
      else {
        this_chance=0;
      }
    }
    var url='assets/img/punt.png';
    if (Math.random()<this_chance) {
      var nr = Math.floor(Math.random() * (nr_tiles-1)) + 1;
      if (nr<10) nr='0'+nr;
      url="assets/img/achtergrond"+nr+".jpg";
    }
    return url;
  }
  
  var back    = $('#background');
  var back_w  = $(back).width();
  var back_h  = $(back).height();
  
  // responsive
  if (back_w<600) tile_size=100;
  
  var count = (Math.floor(back_w/tile_size) * Math.floor((back_h+1)/tile_size));
  var padding = (back_w - (Math.floor(back_w/tile_size) * tile_size)) / 2;

  // Create tiles
  $(back).css({'padding-left':padding}).html('');
  for (var i = 0; i < count; i++) {
    $(back).append('<div class="tile tile_'+i+'"><img src="'+random_tile_url()+'" /></div>');
  }
  // Set tiles
  var tiles = $('.tile',back);
  $(tiles).css({'width':tile_size, 'height':tile_size});
  
  // Fade in/out
  setInterval(function(){
    
    // select random tile
    var rnd_tile=Math.floor(Math.random()*count);
    var tile = $('.tile_'+rnd_tile+' img',back);
    // First fade out
    $(tile).fadeOut(fade,function(){
      // Then select other image
      var src=$(this).attr('src');
      src=random_tile_url(src);
      $(this).attr('src',src);
      // And fade in
      $(this).fadeIn(fade);
    });
    
  },timer);
}
